export const SET_INFO_POPUP = "SET_INFO_POPUP";

export function setInfoPopup(message = "") {
  return {
    type: SET_INFO_POPUP,
    payload: message,
  };
}
